<template>
  <div id="account_allocation">
        <!-- Rendering AccountAllocation starts -->
        <div v-for="(v2,index) in accounting_allocation_arr " track-by="$Index">
            <!-- AccountAllocation header -->
            <div class="yellow-section " style="background-color: #E0F1FC">
                     <h6 class="pt-1 pl-2 pr-2">
                <span class="voucher-label">{{accounting_allocation_key}}</span>
                <span><button
                        id="ACCOUNTINGALLOCATIONS_delete_button"
                        @click="delete_element(index)"
                        class="inventory-submit-btn"
                        style="float:right;"
                        type="submit">-</button></span>
                     </h6>
            </div>
            <div class="card-body ml-0">
                    <div>
                         <div class="dx-field ">
                                <div class="dx-field-label">LEDGER NAME:</div>
                                   <div class="dx-field-value grid grid-cols-2 gap-4">
                                            <div>
                                                <DxSelectBox
                                                @value-changed="handleValueChange" 
                                                :data-source="Headers_cust"
                                                v-model:value="v2.LEDGERNAME"
                                                 />
                                            </div>
                                            <div>
                                                <DxSelectBox
                                                :data-source="ledger_names"
                                                v-model:visible ="selectboxVisiblity"
                                                v-model:value="v2.LEDGERNAME"
                                                 />
                                            </div>
                                   </div>
                        </div>
                        <div class="dx-field">
                                <div class="dx-field-label">AMOUNT:</div>
                                <div class="dx-field-value ">
                                    <DxSelectBox :data-source="Headers" v-model:value="v2.AMOUNT"/>
                                </div>
                        </div>
                        <div class="dx-field">
                                <div class="dx-field-label">ISDEEMEDPOSITIVE:</div>
                                <div class="dx-field-value ">
                                    <DxSelectBox :data-source="is_deemed_positive1" 
                                        display-expr="label"
                                        value-expr="value"
                                        v-model:value="v2.ISDEEMEDPOSITIVE"/>
                                </div>
                        </div>
                    </div>
                <!-- <div class="grid grid-cols-4 gap-2 mb-1">
                    <label class="col-span-1 ml-1" for="">LEDGER
                        NAME:</label>
                    <select class="voucher-select account sm:mr-1 mr-2 ml-40 voucher-select col-span-1 xl:w-36 lg:w-32 sm:w-36 pt-0  leading-4"
                        ng-change="getLedgersName(v.LEDGERNAME)"
                        v-model="v2.LEDGERNAME"
                        id="accounting_LEDGERNAME">
                        <option  v-for="h in Headers " :value="h" v-bind="key">{{h}}</option>
                        <option value="Custom">--Custom--
                        </option>
                    </select>
                    <select
                        class="voucher-select accounting_Custom_ledger_show sm:mr-1 mr-8 ml-28 voucher-select col-span-1 xl:w-36 lg:w-32 sm:w-36 pt-0  leading-4"
                        style="display:none;"
                        v-model="v2.LEDGERNAME"
                        id="Custom_LEDGERNAME">
                        <option  v-for="l in ledger_names " track-by="$Index"  :value="l">{{l}}</option>

                    </select>
                </div> -->
                <!-- <div class="grid grid-cols-4 gap-1">
                    <label class="col-span-1 ml-2 font lg:text-sm md:text-xs sm:text-xs font-semibold " for="">AMOUNT:
                    </label>
                    <select class="voucher-select Custom_ledger_show name mr-11 col-span-3 xl:w-72 lg:w-64 sm:w-72 pt-0 mb-0 leading-4"
                        v-model="v2.AMOUNT" id="">

                        <option  v-for="h in Headers "  :value="h">{{h}}</option>

                    </select><br>
                </div>
                <div class="grid grid-cols-4 gap-1">
                    <label class="col-span-1 ml-2 font lg:text-sm md:text-xs sm:text-xs font-semibold"
                        for="">ISDEEMEDPOSITIVE: </label>
                    <select class="voucher-select Custom_ledger_show name mr-11 col-span-3 xl:w-72 lg:w-64 sm:w-72 pt-0 mb-0 leading-4"
                        v-model="v2.ISDEEMEDPOSITIVE" id="">
                        <option v-for="(value,key) in is_deemed_positive " track-by="$Index" :value="value">{{key}}</option>
                    </select><br>
                </div> -->
            </div>
        </div>
        <!-- Rendering AccountAllocation ends -->
    </div>
</template>

<script>
import DxSelectBox from 'devextreme-vue/select-box';
export default {
    name:'accountingallocation',
    components: {
            DxSelectBox
    },
     data: function() {
        return {
           custom_value:["--CUSTOM--"], 
            // added new variable
            selectboxVisiblity:false,
        }
    },
    props:{
        accounting_allocation_arr:{
          type:Array,
          default: {}
        },
        Headers:{
          type:Array,
          default: {}
        },
        ledger_names:{
          type:Array,
          default: {}
        },
        is_deemed_positive:{},
         is_deemed_positive1:{
          type:Array,
          default: {}
        },
        accounting_allocation_key:"",
        Headers_cust:{
          type:Array,
          default: {}
        }
    },
    methods:{
        delete_element(index){
            this.accounting_allocation_arr.splice(index,1)
        },
         //// Select combobox  new code added------///
        handleValueChange(e){
        if(e.value=="--CUSTOM--"){  
        this.selectboxVisiblity =true;
        }
    },
    },
}
</script>

<style>
/* #account_allocation { 
    /* padding-left:-35px; */
    /* padding-right: 20px;
    border-radius: 5px;
} */
.account{
    width: 290px;
    margin-left: 33%;
}
</style>